import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PERMISSION } from '../../helpers'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../index'

const { env } = window

const useProjectUserMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const updateUser = async (id, property, value, extra) => {
    const url = encodeURI(`${env.apiUrl}/manageUsers/${id}`)
    const body = {}
    body[property] = value
    if (property === 'permission' && value === PERMISSION.DENIED) {
      body.reason = extra.reason
      body.comment = extra.comment
    }
    const response = await securedFetch(url, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ id, property, value, extra }) =>
      updateUser(id, property, value, extra),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error updating user permission'),
    onSuccess: () => {
      setMessage('Updated user permission')
      queryClient.invalidateQueries({ queryKey: ['users'] })
    },
    onSettled: progressEnd
  })
}

export { useProjectUserMutation }
